import { IReceivingPoint } from '@/modules/seller-account/ts';
import { notification } from 'antd';
import { fetchBuyerPointsFx, updateBuyerPointFx } from '../store/points.store';

export const updateBuyerPoint = async ({
  nameString,
  hasMixer,
  pointName,
  pointForEditId,
  clearValue,
  state,
}: {
  pointName: IReceivingPoint;
  pointForEditId: number;
  hasMixer: number;
  clearValue?: () => void;
  state?: 'enabled' | 'disabled';
  nameString: string;
}) => {
  try {
    const res = await updateBuyerPointFx({
      id: pointForEditId,
      name: nameString,
      region: pointName.region,
      city: pointName.area,
      street: pointName.street,
      house: pointName.house,
      latitude: pointName.latitude,
      longitude: pointName.longitude,
      enabled: pointName.enabled,
      has_mixer: hasMixer,
    });
    await fetchBuyerPointsFx();
    return res;
  } catch (err: any) {
    const res = err.body && await err.json();
    return notification.error({
      message: res.error ? res.error : 'Непредвиденная ошибка. Попробуйте позже',
    });
  }
};
